<template>
  <Dialog class="dialog" ref="dialog" :title="title" @closed="onClose">
    <template #default>
      <!-- 运费单价表单控件 -->
      <!-- <el-form class="modalForm" :model="mform">
        <FormItem v-for="(c, i) in mformCtrl" :key="'mformItem' + i" :viewMode="false" :config="c" :options="c.options"
          :inputValue="mform[c.keyName]" @onChange="onModalChange" />
      </el-form> -->
      <!-- 弹窗搜索控件 -->
      <el-form class="searchForm" :model="modalSearchForm">
        <FormItem v-for="(c, i) in modalSearchFormCtrl" :key="'msformItem' + i" :viewMode="false" :config="c"
          :options="c.options" :inputValue="modalSearchForm[c.keyName]" @onChange="onSearchFormChange" />

        <el-form-item>
          <el-button type="primary" @click="getCars">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button plain @click="onModalSearchReset">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- 时间控件 -->
      <el-form class="searchForm modalForm" :model="mform">
        <FormItem v-for="(c, i) in mformCtrl2" :key="'mform2Item' + i" :viewMode="false" :config="c"
          :options="c.options" :inputValue="mform[c.keyName]" @onChange="onModalChange" />
      </el-form>
      <!-- 滚动列表 -->
      <el-scrollbar class="modal-scroll">
        <div class="tit tit1">空闲车辆</div>
        <el-checkbox-group class="list" v-model="checkedLists" @change="onCheckChange">
          <el-checkbox class="item" v-for="(c, i) in cars" :key="'car' + i" :label="c.id" v-show="c.isorder == 1">
            <div class="row0">{{ c.license }}</div>
            <div class="row1">{{ c.driver }}</div>
          </el-checkbox>
        </el-checkbox-group>

        <div class="tit tit2">在途车辆</div>
        <el-checkbox-group class="list" v-model="checkedLists" @change="onCheckChange">
          <el-checkbox class="item" v-for="(c, i) in cars" :key="'car2' + i" :label="c.id" v-show="c.isorder == 2">
            <div class="row0">{{ c.license }}</div>
            <div class="row1">{{ c.driver }}</div>
          </el-checkbox>
        </el-checkbox-group>
      </el-scrollbar>

      <div class="btns">
        <el-button type="primary" @click="modalSubmitConfirm">确 定</el-button>
        <el-button @click="hide">取 消</el-button>
      </div>
    </template>
  </Dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    labelWidth: String,
    form: Object,
    formCtrl: Array,
    rules: Object,
    viewMode: Boolean,
    width: String,
  },
  computed: {
    ...mapState([
      'user',
      'store',
    ]),
  },
  data() {
    return {
      title: '车辆列表',
      modalSearchForm: {},
      modalSearchFormCtrl: [
        {
          label: "",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
        },
      ],
      mform: {},
      mformCtrl: [
        {
          // label: "运费单价：",
          label: "",
          keyName: "dprice",
          err: "在此输入运费单价",
          type: "number",
          unit: "元",
        },
      ],
      mformCtrl2: [
        {
          ...this.ctrls.ZhuangHuoRiQi,
          label: "装货日期：",
        },
        {
          ...this.ctrls.XieHuoRiQi,
          label: "卸货日期：",
        },
      ],
      cars: [],
      checkedLists: [],
    };
  },
  methods: {
    onModalChange({ key, value }) {
      // console.log(key, value)
      // this.mform[key] = value;
      this.$set(this.mform, key, value)
      // console.log({ ...this.mform })
    },
    onSearchFormChange({ key, value }) {
      // console.log(key, value)
      this.modalSearchForm[key] = value;
      // console.log({ ...this.modalSearchForm })
    },
    onModalSearchReset() {
      this.modalSearchForm = {}
      this.getCars()
    },
    onCheckChange(v) {
      console.log(v)
      this.mform.car_list = v
    },
    modalSubmitConfirm() {
      // console.log(this.checkedLists);
      const { car_list, predict_loading_date, predict_unloading_date } = this.mform
      if (!car_list || !car_list.length) {
        this.$message({
          type: 'error',
          message: '请选择车辆！'
        });
        return
      }
      // if (!dprice) {
      //   this.$message({
      //     type: 'error',
      //     message: '请填写单价！'
      //   });
      //   return
      // }
      if (!predict_loading_date) {
        this.$message({
          type: 'error',
          message: '请填写装货日期！'
        });
        return
      }
      if (!predict_unloading_date) {
        this.$message({
          type: 'error',
          message: '请填写卸货日期！'
        });
        return
      }
      // console.log({ ...this.mform });
      this.$confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(this.onModalSubmit).catch(() => { });
    },
    onModalSubmit() {
      // console.log({ ...data })
      console.log({ ...this.mform })
      this.loading = true
      let url = `order/addedu`;
      const params = {
        userid: this.user.id,
        ...this.mform
      }
      // this.paramsPackage(params, this.mform)
      // console.log(url, params)
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hide()
          this.$emit("onDispatched");
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    getCars() {
      this.cars = []
      let url = `order/searchcar`;
      const params = {
        userid: this.user.id,
      }
      const object = this.modalSearchForm
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key) && object[key]) {
          params[key] = object[key];
        }
      }
      // console.log(url, params)
      this.post(url, params, ({ driver }) => {
        if (driver && driver.length) {
          this.cars.push(...driver)
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    show() {
      this.$refs.dialog && this.$refs.dialog.show()
    },
    hide() {
      this.$refs.dialog && this.$refs.dialog.hide()
    },
    onClose() {
      // console.log('mform', { ...this.mform})
      if (this.$refs['mform']) {
        // console.log(this.$refs['mform'].resetFields)
        this.$refs['mform'].resetFields();
      }
      this.$set(this.modalSearchForm, 'license', '')
      this.$set(this.mform, 'predict_loading_date', '')
      this.$set(this.mform, 'predict_unloading_date', '')
      // console.log('mform', { ...this.mform})
    },
  },
  mounted() {
    this.getCars()
  },
};
</script>

<style lang="less" scoped>
.dialog {
  /deep/ .el-dialog {
    width: 950px;
  }

  .searchForm {
    display: flex;

    /deep/ .el-form-item {
      .el-form-item__content {
        .el-input {
          input {
            background: #fff;
          }
        }
      }

      &:not(:first-of-type) {
        margin-left: 15px;
      }
    }

    &:nth-child(3) {
      /deep/ .el-form-item {
        .el-form-item__content {
          .el-input {
            width: 250px;
          }
        }
      }
    }
  }

  .modalForm {
    position: absolute;
    right: 20px;
    top: 84px;

    /deep/ .el-form-item {
      .el-form-item__content {
        .el-input {
          width: 250px;

          input {
            // width: 190px;
            padding-right: 20px;
            background: #fff;
          }
        }

        .unit {
          position: absolute;
          right: 10px;
        }
      }
    }
  }

  .tit {
    line-height: 20px;
    font-size: 15px;
    font-weight: bold;
    color: #303133;
    padding-left: 16px;
    position: relative;
    margin: 0 auto 16px;

    &::before {
      position: absolute;
      left: 0;
      top: 5px;
      content: '';
      width: 10px;
      height: 10px;
      background: #67C23A;
      border-radius: 50%;
    }

    &.tit2 {
      &::before {
        background: #F56C6C;
      }
    }
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    max-height: 450px;

    .item {
      background: #FAFAFA;
      border-radius: 6px;
      border: 1px solid #FAFAFA;
      position: relative;
      margin: 0 15px 15px 0;
      position: relative;
      min-width: 136px;
      box-sizing: border-box;

      &:nth-child(4n) {
        margin-right: 0;
      }

      /deep/ .el-checkbox__input {
        position: absolute;
        right: 14px;
        top: 15px;
      }

      /deep/ .el-checkbox__label {
        padding: 0;
        display: block;
        width: 100%;
      }

      .row0 {
        padding: 15px 40px 15px 15px;
        height: 14px;
        font-size: 14px;
        color: #303133;
        border-bottom: 1px solid #EBEEF5;
      }

      .row1 {
        padding: 10px 15px 15px;
        height: 14px;
        font-size: 14px;
        color: #909399;
      }
    }
  }

  .btns {
    text-align: center;
    margin: 40px auto 20px;
  }
}
</style>
